//
// Copyright 2026 DXOS.org
//
import * as Context from 'effect/Context';
import * as Rpc from 'effect/rpc/Rpc';
import * as RpcGroup from 'effect/rpc/RpcGroup';
import { ContactBookSchema } from './buf/proto/gen/dxos/client/services_pb.js';
import { bufMessage, serviceError } from './service-rpc.js';
/**
 * Effect RPC definitions for the client contacts service (formerly `dxos.client.services.ContactsService`).
 * Both methods take no payload; the response reuses the shared `ContactBook` proto type.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('getContacts', {
    success: bufMessage(ContactBookSchema),
    error: serviceError,
}), Rpc.make('queryContacts', {
    success: bufMessage(ContactBookSchema),
    error: serviceError,
    stream: true,
})).prefix('ContactsService.') {
}
/**
 * Effect service tag for the `ContactsService` RPC handlers.
 */
export class Tag extends Context.Service()('@dxos/protocols/rpc/ContactsService') {
}
//# sourceMappingURL=ContactsService.js.map